import Config from 'es6/core/config';
import { base64Encode } from 'es6/helpers/string';

const loadedImages = new Map();

function getTranscodeSubDomain(url) {
  let hash = 0;

  for (let i = 0; i < url.length; i++) {
    hash += url.charCodeAt(i) * (i + 1);
  }

  return Math.abs(hash) % Config.getTranscoderCdns();
}

export const clear = () => loadedImages.clear();

/**
 * Given a URL and some options, generate a transcoded URL.
 *
 * @param {String} url path to original image
 * @param {Number} options.width
 * @param {Number} options.height
 *
 * Returns a string of the transcoded URL.
 */
export const getTranscodedUrl = (url, { width, height } = {}) => {
  let params = '';
  const match = url.match(/\/([^?/.]+)(\.[^?/.]+)*(?:\??[^/]*)$/);

  if (!match) {
    return url;
  }

  if (width && height) {
    params = `_${width}x${height}`;
  }

  const file       = match[1];
  const ext        = match[2] || '.jpg';
  const encodedUrl = base64Encode(url);
  const subDomain  = getTranscodeSubDomain(url);
  const domain     = Config.getTranscoderHost().replace(/%d/, subDomain);

  return `//${domain}/t/${encodedUrl}/${file}${params}${ext}`;
};

export const get = (src) => loadedImages.get(src);

/**
 * Preloads an image. Returns a promise that on success, gives
 * the image back.
 *
 * @param {String} src   URL of image to load
 * @returns {Promise}
 */
export const load = (src) => new Promise((resolve, reject) => {
  if (loadedImages.has(src)) {
    resolve(loadedImages.get(src));
  } else {
    const image = new Image();

    image.addEventListener('load', () => {
      loadedImages.set(src, image);
      resolve(image);
    });

    image.addEventListener('error', () => reject(new Error(`Error loading image ${src}`)));

    image.src = src;
  }
});

export const remove = (src) => loadedImages.delete(src);
